import dinoHeadUrl from '@/public/static/dino-head.svg'
import logoUrl from '@/public/static/logo.svg'
import { configureChat } from '~/chat-widget'

export default defineNuxtPlugin(() => {
  configureChat({
    apiBase: 'https://sysreptor-ai.external.syslifters.com',
    iconSrc: logoUrl,
    launcherIconSrc: dinoHeadUrl,
  })
})
